const people = {
    DanzelPinto: {
        title: '100% All-in',
        body: [
            `Danzel Pinto is 100% all in. He gets involved in everything at the firm. He’s a huge fan of Doane Grant Thornton – and ignites that passion in everyone around him. New to the Markham office? Danzel makes it his mission to get to know not only your name, but who you are, what drives you, what your hobbies are, what your favourite snack is. And he’ll check in on you weeks, even months later to make sure you’re settling in ok. `,
            `And coming out to social events. Like the one he organized a few years ago. Lots of people might plan a lunch or a Jays game – but not Danzel. He set up a day-long scavenger hunt that took his Markham colleagues all over downtown Toronto – and people still talk about it today. Remember that time Danzel made us run all over the lakeshore … and through the Eaton Centre … and up Bay Street!?! And charity events? While most people just show up in bike shorts and t-shirts to help raise funds for the annual Juvenile Diabetes Revolution Ride, Danzel appears out of nowhere wearing a purple cape.`,
            `Whether he’s taking engagement teams out for much-deserved lunches, encouraging our manager group into a millennial panel for a room full of clients, showing our students the ropes so they don’t feel overwhelmed, or being the most enthusiastic volunteer Treasurer our Foundation Board has ever seen, Danzel leads by example - encourages, supports and energizes. And his passion makes us all better. <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Danzel Pinto',
            job: 'Principal, Assurance'
        },
        images: [
            {
                media: '1_Danzel_Pinto',
                type: 'image'
            },
            {
                media: '2_Danzel_Pinto',
                type: 'image'
            }
        ],
    },
    ChrisDuda: {
        title: 'The Butterfly Effect',
        body: [
            `Joining the firm in September 2021 after graduating from Simon Fraser University, Chris’ only accounting experience came from school and a few part-time jobs. He was soon learning all about Canadian Tax, compilations, and reviews, and on January 1, 2023 was promoted to Senior Accountant. “I decided to say yes to opportunities, which opened up a tonne of useful doors,” he says. Like when two colleagues asked him to join a Community Committee meeting during work one day. Now, Chris serves as Secretary on the Committee, which provides volunteer opportunities for colleagues in their local communities and helps direct financial support from the Doane Grant Thornton Foundation to community organizations selected by Doane Grant Thornton people.`,
            `Then, when Partners in the office asked him to emcee the 2022 Doane Grant Thornton Foundation Greater Purpose event, Chris said yes (of course!). “The most growth happens outside your comfort zone,” he says. And even though it was something unplanned and unexpected, Chris is happy about where it’s led him. “It’s like the butterfly effect – even a small step can have a huge impact. It feels great knowing I can contribute to helping people in our community thrive and make a difference in their lives.” <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Chris Duda',
            job: 'Senior Accountant, Independent Business Group'
        },
        images: [
            {
                media: 'Chris_Duda_1',
                type: 'image'
            },
            {
                media: 'Chris_Duda_2',
                type: 'image'
            },
        ],
    },
    AllisonButcher: {
        title: 'Helping colleagues thrive',
        author: {
            name: 'Allison Butcher',
            job: 'Principal, Assurance'
        },
        body: [
            `Audit technology can change, but how we use it shouldn’t. That’s what Allison Butcher tells new students and juniors when she’s training them or helping them get unstuck in the software. It’s a strategic approach she learned during her more than 10 years at the firm, getting training on several different accounting systems and applying them to help her colleagues and clients thrive. Understanding what you’re doing and why you’re using a particular procedure – getting the accounting software to work for you to make your life easier – is key. That’s why looking at technology with a fresh perspective helps Allison make a powerful impact on her colleagues every day. Then, when she combines her software superpowers with her knowledge of our Cloud Services, she’s just about unstoppable. She uncovers the pain points her clients have when they use the accounting system and finds cloud solutions to help relieve their stress and make things more efficient. `,
            `Having that insatiable curiosity to learn and drive to make things better. To improve systems that impact colleagues down the hall and clients down the street. To take a new look at everyday resources for the benefit of everyone. <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        images: [
            {
                media: '1_Allison_Butcher',
                type: 'image'
            },
        ]
    },
    MelissaSkinner: {
        title: 'Fresh Perspectives',
        author: {
            name: 'Melissa Skinner',
            job: 'Senior Manager'
        },
        body: [
            `Going from working with 15 people in her office in Corner Brook, Newfoundland, to collaborating with more than 50 professionals in the Audit practice alone while on a six-month secondment to the firm’s Birmingham, UK, office, put Melissa Skinner a little out of her comfort zone. But it was also an opportunity to grow and challenge herself.`,
            `She got to meet people from all sorts of backgrounds and with different perspectives, which armed her with new strategies for coaching and motivating her team when she was promoted to manager soon after getting back. She learned UK-specific auditing approaches she’s since applied to engagements in the Corner Brook office that helped her and her colleagues complete audits faster for their clients.`,
            `Working in a small office where everyone knows each other is awesome. But it’s also nice to know what travelling more than 4,000 km can give you: fresh perspectives, new strategies and a global network you can always rely on. <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        images: [
            {
                media: '2_Melissa_Skinner',
                type: 'image'
            },
        ]
    },
}

const allStories = [
[
{
    slug: 'leads-by-example',
    theme: 'one-photo',
    title: 'Rockin an’ rollin!',
    body: [
        `“He’s the most enthusiastic person I ever met.” “He inspires me to be a better leader.” “He promotes everyone else over himself.” “You’re always in a good mood when you’re around him.” If you ask anyone about Ryan Wildman, these are the kinds of things you’ll hear. And when he’s in the office – everyone knows it. The energy level goes up. People feel uplifted. Confident. Good about themselves. Ryan exudes positive energy and his colleagues become positivity ambassadors, too – sometimes without even realizing it. Like Angela Myers. When she needed to take time off work for personal reasons, Ryan put her first and never made her feel guilty about it. When you talk to Angela, you can hear her smiling on the other end of the line. Or Greg Weber. Even though they haven’t worked together in years, Ryan still checks in with Greg every Friday – just to see how he’s doing. Now Greg stops to chat more often too – because it makes him feel so good. Or Lindsay Dvornik. Ryan supported her with passion and enthusiasm when she transformed our CPA program. Lindsay now passes that energy on to our students.`,
        'Whether he’s empowering people to try new things, finding “the good news” in every situation, or complimenting his colleagues on doing such great jobs – “everyone’s rockin an’ rollin!” – Ryan sees we’re at our absolute best when we’re fired up – so he makes sure we are. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Ryan Wildman',
        job: 'Partner, Assurance'
    },
    images: [
        {
            media: 'Ryan_Wildman',
            type: 'image'
        }
    ],
    nav: {
        next: 'insatiable-curiosity'
    }
},
{

    ...people.DanzelPinto,
    slug: 'leads-by-example',
    theme: 'two-photo',
    nav: {
        next: 'insatiable-curiosity'
    }

},
{

    ...people.ChrisDuda,
    slug: 'leads-by-example',
    theme: 'two-photo',
    nav: {
        next: 'insatiable-curiosity'
    }

},
{
    slug: 'leads-by-example',
    theme: 'staggered',
    title: 'What would I do if?...',
    body: [
        'Attending business family client meetings starting early on in her career gave Krista Han a wealth of experience to draw on when developing ideas for building her practice. Often, she was about the age of her clients’ children – the next generation owners, who sat beside their parents across from her at the boardroom table. And she remembers thinking at the time, “how would I feel about succession if I were in their shoes?” Since then, she’s brought that same next-generation perspective to bear for the benefit of her clients – what would I do if…? Plus, along with about 20 other colleagues across Canada, she earned the Family Enterprise Advisor designation, which helps her imagine what the future could look like for business families and how we can help. It’s led Krista and her team to see around the corner, uncovering new and valuable services that help business families make strategic decisions, drive change and navigate those critical transitions from one generation to the next – in ways that fit them best. ',
        'Learning and contributing from the get-go. Staying tuned into the dreams and passions of family businesses. Building that knowledge into the practice. Delivering it in innovative ways – right when they need it.  <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Krista Han',
        job: 'Managing Partner'
    },
    images: [
        {
            media: '1_Krista_Han',
            type: 'image'
        },
        {
            media: '2_Krista_Han',
            type: 'image'
        }
    ],
    nav: {
        next: 'insatiable-curiosity'
    }
},

], [

{
    slug: 'insatiable-curiosity',
    theme: 'one-photo',
    title: 'Stepping outside my comfort zone',
    body: [
        `In less than four years, Anthony progressed from Tax Analyst to Tax Manager - from someone hesitant to speak out in client meetings, to someone who’s comfortable sharing his perspectives. It’s not something he really saw himself doing when he first started his career at the firm. “But you just have to do it,” he says. “And the Doane Grant Thornton culture really helps. I can be myself here because everyone is accepting. I can follow my curiosity, try different things and push myself out of my comfort zone and it’s ok because everyone has my back.”`,
        `Anthony worked on his soft skills over the years as his leaders gave him opportunities to interact with clients, lead teams, and even give internal training presentations. All these new experiences helped build his confidence and he’s amazed at how much he’s grown as a professional. In 2021, Anthony said yes to an interview for a feature in Business in Vancouver, and he’s applied to present at a conference in 2023. “Over time, you become more directed in your efforts,” he says. “And if you keep learning, stay curious and work on your skills, it’s incredible how much you can grow in a few years.” <strong>That’s our purple. Discover yours.</strong>`,
    ],
    author: {
        name: 'Anthony Jay',
        job: 'Senior Manager, Tax'
    },
    images: [
        {
            media: 'Anthony_Jay_1',
            type: 'image'
        },
    ],
    nav: {
        prev: 'leads-by-example',
        next: 'courage-to-grow'
    }
},
{
    slug: 'insatiable-curiosity',
    theme: 'two-photo',
    title: 'Chasing her curiosity',
    body: [
        `Just because we’ve finished school, doesn’t mean we’ve finished learning and growing. Launesha Grant knows this firsthand. After an initial stint in our Summerside, PEI office she was able to move to Toronto in order to chase her curiosity and determine where her interests align with the Firm’s. In addition to finding friendly connections in each of our offices, she discovered a great role within our Risk and Forensics practice.`,
        `As she builds her own unique career journey, she’ll be able to take advantage of other learning opportunities including formal leadership and professional development programs, core business skills courses and our Colleague Growth Centre. And thanks to our commitment to shared leadership, which helps foster experiential, in-the-moment learning, she’s always encouraged to ask questions and is reminded that everyone is there to help.`,
        `Although she’s been in her new role for less than a year, thanks to confidence building feedback she’s received and access to advanced training, she’s already talking about her next career step of becoming a senior associate. Having managers who have taken an interest and connected her with the right people to explore her interests has made all the difference.`,
        'Excited to come to work every day. Empowered to explore your insatiable curiosity wherever it leads you. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Launesha Grant',
        job: 'Senior Associate, Risk & Forensics'
    },
    images: [
        {
            media: 'Launesha_Grant_1',
            type: 'image'
        },
        {
            media: 'Launesha_Grant_2',
            type: 'image'
        },
    ],
    nav: {
        prev: 'leads-by-example',
        next: 'courage-to-grow'
    }
},

], [

{
    slug: 'courage-to-grow',
    theme: 'video--single',
    title: 'Being surrounded by people who care',
    body: [
        'When Jessica Eisenhauer stepped up to lead the Halifax office’s intense tax return process this year, that saw her coordinate the preparation and review of 3,500 tax returns by a team of about 25 professionals during the month of April, she knew what she was getting into. She was a preparer in the past, but this was her first time leading the whole process in the Halifax office, which has the largest T1 practice in the firm. But Jessica loves a challenge and saw an opportunity to step outside her comfort zone and grow professionally. And since the project included leading training for everyone involved – something she’s keen to do and well known for among her colleagues – she was even more psyched to do it. Plus, she knew the partners who presented her with the opportunity would support her and help her make sure it was a success.',
        'Keeping the team motivated and the momentum going, constantly answering questions, training interns on returns and managers on process, and discussing issues with Tax partners – all the while doing her regular client work – meant longer hours, but it also provided valuable services the office’s T1 clients appreciated – plus it was a fantastic chance to learn new skills and build stronger relationships with her colleagues. So much so, she’s ready to do it all over again next year. (Way to go, Jessica!) <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Jessica Eisenhauer',
        job: 'Senior Manager, Independent Business Group'
    },
    images: [
        {
            media: 'Jessica_Eisenhauer',
            type: 'video'
        }
    ],
    nav: {
        prev: 'leads-by-example',
        next: 'walk-in-others-shoes'
    }
},

], [

{
    slug: 'walks-in-others-shoes',
    theme: 'one-photo',
    title: 'We’ve got your back',
    body: [
        'Since joining Doane Grant Thornton as a partner in March 2017, what sticks out the most for Rob Zompanti about life at the firm is our strong focus on support – and he sees it everywhere he looks. His fellow partners are down-to-earth, easy to talk to and quick to pick up the phone when he calls to ask a question or bounce ideas off them. We have his back. He loves that Audit, Advisory and his specialty, Tax, are valued equally across the firm and that as a growth area, Tax is considered a revenue driver. Tax rocks. He respects the priority Doane Grant Thornton places on its private company clients – and that the expertise he accumulated over decades of serving family businesses is not only appreciated, but shared by every other partner here. Each client is our most important client.',
        'Plus, Rob sees how all this support and shared focus at the partner level trickles down. The people on his team feel as appreciated and respected for the important work they do as he does. And his clients feel just as prized and supported, too. Putting we before me helped Rob build a successful practice. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Rob Zompanti',
        job: 'Partner, Tax'
    },
    images: [
        {
            media: '1_Rob_Zompanti',
            type: 'image'
        }
    ],
    nav: {
        prev: 'courage-to-grow'
    }
},

]
]

const experiencedStories = () => allStories.map((stories, x) => {
    if (x === 2) { // courage
        return [
            ...stories,
            {
                ...people.MelissaSkinner,
                slug: 'courage-to-grow',
                theme: 'one-photo',
                nav: {
                    prev: 'leads-by-example',
                    next: 'walk-in-others-shoes'
                }
            }
        ]
    }
    return stories
})

export default {
    student: allStories,
    experienced: experiencedStories(),
}